<div class="position-relative with-sidebar w-100 h-100 d-flex flex-column">
  <!-- Si touareg controller est activé dans les settings -->
  <ng-container *ngIf="health.active; else noactive">
    <ng-container
      *ngIf="
        !health.tooMuchLatency && health.status === 'connected';
        else connexionlost
      "
    >
      <!-- Toolbar -->
      <div class="tc-header">
        <app-touareg-control-toolbar
          (close)="close.emit($event)"
        ></app-touareg-control-toolbar>
      </div>

      <!-- Switch sur les differents états -->
      <div class="tc-body" [ngSwitch]="currentState?.state">
        <!-- <div class="grow h-auto" [ngSwitch]="test"> -->
        <!-- State IDLE -->
        <app-touareg-control-state-idle
          *ngSwitchCase="'IDLE'"
          [state]="currentState!"
        ></app-touareg-control-state-idle>

        <!-- State PICKING_SCANNING -->
        <app-touareg-control-state-pick-candidate
          *ngSwitchCase="'PICKING_SCANNING'"
          [state]="currentState!"
        ></app-touareg-control-state-pick-candidate>

        <!-- State PICKED -->
        <app-touareg-control-state-pick
          *ngSwitchCase="'PICKED'"
          [state]="currentState!"
        ></app-touareg-control-state-pick>

        <!-- State DROP_SCANNING -->
        <app-touareg-control-state-drop
          *ngSwitchCase="'DROP_SCANNING'"
          [state]="currentState!"
        ></app-touareg-control-state-drop>

        <!-- State DROP_ACCEPTING_USER_CHOICE -->
        <app-touareg-control-state-accepting-user-choice
          *ngSwitchCase="'DROP_ACCEPTING_USER_CHOICE'"
          [state]="currentState!"
          (waitingComplete)="onWaitingComplete()"
        ></app-touareg-control-state-accepting-user-choice>

        <!-- State DROP_BLOCKED_BY_USER -->
        <app-touareg-control-state-drop-blocked-by-user
          *ngSwitchCase="'DROP_BLOCKED_BY_USER'"
          [state]="currentState!"
        ></app-touareg-control-state-drop-blocked-by-user>

        <!-- NO STATE !!! -->
        <div *ngSwitchDefault class="h-100">
          <app-touareg-control-state-layout
            [noShow]="true"
            noShowMessage="Connect Touareg. Please wait..."
          ></app-touareg-control-state-layout>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- Si touareg controller n'est pas activé dans les settings -->
  <ng-template #noactive>
    <div class="tc-header">
      <div class="w-100 d-flex align-items-center justify-content-end">
        <button mat-icon-button (click)="close.emit($event)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div class="tc-body d-flex flex-center">
      <span>Touareg front controller is not activated.</span>
    </div>
  </ng-template>

  <!-- Si touareg controller ne reçois plus de data de la machine -->
  <ng-template #connexionlost>
    <div class="tc-header">
      <app-touareg-control-toolbar
        (close)="close.emit($event)"
      ></app-touareg-control-toolbar>
    </div>
    <div class="tc-body d-flex flex-center flex-column">
      <p class="mb-2 text-2">Connection lost...</p>
      <p>
        Please check your network, or visit Mahvis
        <a routerLink="/mahvis/settings" (click)="close.emit($event)"
          >settings page</a
        >.
      </p>
    </div>
  </ng-template>
</div>
